'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { appendHostAndBasePath } from '@/utils/urls';
import './CommunitySubNav.scss';

type SubNavItem = {
  label: string;
  href: string;
  target?: string;
};

type CommunitySubNavProps = {
  items: SubNavItem[];
  title?: string;
};

const CommunitySubNav: React.FC<CommunitySubNavProps> = ({ items, title = 'Champions' }) => {
  const pathname = usePathname();

  return (
    <div className="community-subnav-wrapper">
      <div className="community-subnav-links">
        <span className="l1-title">{title}</span>
        {items.map(item => {
          const isActive = pathname === item.href || pathname === `${item.href}/`;
          return item.target === '_blank' ? (
            <a
              key={item.href}
              href={appendHostAndBasePath(item.href)}
              target={item.target}
              rel="noopener noreferrer"
              className={`community-subnav-link${isActive ? ' active' : ''}`}
            >
              {item.label}
            </a>
          ) : (
            <Link
              key={item.href}
              href={appendHostAndBasePath(item.href)}
              className={`community-subnav-link${isActive ? ' active' : ''}`}
            >
              {item.label}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default CommunitySubNav;
